module.exports = __webpack_public_path__ + "img/box.2a225178.svg";